import * as React from "react";
import { cn } from "../../lib/utils";

function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        "animate-pulse rounded-md bg-muted/70 bg-[linear-gradient(90deg,hsl(var(--muted)/0.6)_0%,hsl(var(--muted)/0.9)_50%,hsl(var(--muted)/0.6)_100%)] bg-[length:200%_100%] animate-shimmer",
        className
      )}
      {...props}
    />
  );
}

export { Skeleton };
